"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardColor = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _heading = _interopRequireWildcard(require("../heading"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Card
// ====
var CardColor;
exports.CardColor = CardColor;

(function (CardColor) {
  CardColor["white"] = "white";
  CardColor["none"] = "none";
})(CardColor || (exports.CardColor = CardColor = {}));

var CardHeader = function CardHeader(_ref) {
  var title = _ref.title,
      heading = _ref.heading,
      headingProps = _ref.headingProps,
      headerElement = _ref.headerElement,
      headerUnderline = _ref.headerUnderline;

  var headerElements = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.title
  }, title), heading && /*#__PURE__*/_react.default.createElement(_heading.default, (0, _extends2.default)({
    type: _heading.HeadingSize.large
  }, headingProps), heading), headerElement && /*#__PURE__*/_react.default.createElement("div", null, headerElement));

  return headerUnderline ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, _indexModule.default.headerUnderlined, headerUnderline))
  }, headerElements) : headerElements;
};

CardHeader.propTypes = {
  title: _propTypes.default.string,
  heading: _propTypes.default.string,
  headerElement: _propTypes.default.node,
  headerUnderline: _propTypes.default.bool
};

var Card = function Card(_ref2) {
  var _cx2;

  var title = _ref2.title,
      heading = _ref2.heading,
      headingProps = _ref2.headingProps,
      className = _ref2.className,
      children = _ref2.children,
      headerElement = _ref2.headerElement,
      _ref2$cardColor = _ref2.cardColor,
      cardColor = _ref2$cardColor === void 0 ? CardColor.white : _ref2$cardColor,
      _ref2$headerUnderline = _ref2.headerUnderline,
      headerUnderline = _ref2$headerUnderline === void 0 ? false : _ref2$headerUnderline,
      _ref2$cardPadding = _ref2.cardPadding,
      cardPadding = _ref2$cardPadding === void 0 ? true : _ref2$cardPadding;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, (_cx2 = {}, (0, _defineProperty2.default)(_cx2, _indexModule.default.cardWhite, cardColor === CardColor.white), (0, _defineProperty2.default)(_cx2, _indexModule.default.cardPadding, cardPadding), _cx2))
  }, /*#__PURE__*/_react.default.createElement(CardHeader, {
    title: title,
    heading: heading,
    headingProps: headingProps,
    headerElement: headerElement,
    headerUnderline: headerUnderline
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.childrenWrapper
  }, children));
};

Card.propTypes = {
  title: _propTypes.default.string,
  heading: _propTypes.default.string,
  headerElement: _propTypes.default.node,
  headerUnderline: _propTypes.default.bool,
  className: _propTypes.default.string,
  cardColor: _propTypes.default.any,
  cardPadding: _propTypes.default.bool
};
var _default = Card;
exports.default = _default;